const baseUrl = "/consumer-360";

export default {
  baseUrl,
  CONSUMER_PROFILES: baseUrl,
};
